import React, { useCallback, useEffect, useState } from 'react';
import style from '../css/Accepted.module.css';
import { FaSpinner } from 'react-icons/fa6';
import BottomTab from './BottomTab';
import HeaderBar from '../components/HeaderBar';

const Accepted = () => {
	const [bookings, setBookings] = useState([]);
	const [loading, setLoading] = useState(true);
	const [refreshing, setRefreshing] = useState(false);
	const [error, setError] = useState();

	const fetchAgentID = () => {
		return localStorage.getItem('user_id');
	};

	const fetchAcceptedBookings = async () => {
		setLoading(true);
		const agentID = fetchAgentID();
		if (!agentID) return;

		try {
			const response = await fetch(
				`https://hometech-repairs.in/homeTech/fetch_accepted_bookings.php?agent_id=${agentID}`
			);
			const result = await response.json();

			if (result.status) {
				setBookings(result.data);
			} else {
				setBookings([]);
				setError(result.msg);
			}
		} catch (error) {
			setError('Failed to fetch accepted bookings');
		} finally {
			setLoading(false);
			setRefreshing(false);
		}
	};

	const updateBookingStatus = async (orderNumber) => {
		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/update_booking_status.php',
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ order_number: orderNumber }),
				}
			);
			const result = await response.json();
			setError(result.msg);
			if (result.status) fetchAcceptedBookings();
		} catch (error) {
			setError('Failed to update booking status');
		}
	};

	const cancelBook = async (orderNumber) => {
		try {
			const response = await fetch(
				'https://hometech-repairs.in/homeTech/cancel_booking.php',
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ order_number: orderNumber }),
				}
			);
			const result = await response.json();
			setError(result.msg);
			if (result.status) fetchAcceptedBookings();
		} catch (error) {
			setError('Failed to update booking status');
		}
	};

	useEffect(() => {
		fetchAcceptedBookings();
	}, []);

	const onRefresh = useCallback(() => {
		setRefreshing(true);
		fetchAcceptedBookings();
	}, []);

	return (
		<div className={style.container}>
			<HeaderBar title={'Accepted'} />
			<button className={style.refreshButton} onClick={onRefresh}>
				<FaSpinner size={20} color="white" />
			</button>
			{loading ? (
				<div className={style.loader}>Loading...</div>
			) : (
				<div className={style.list}>
					<p>{error}</p>
					{bookings.length > 0 ? (
						bookings.map((item) => (
							<div key={item.order_number} className={style.card}>
								<p className={style.date}>
									{new Date(item.date).toLocaleDateString('en-GB')}
								</p>
								<h2 className={style.orderNumber}>
									Order #: {item.order_number}
								</h2>
								<p className={`${style.status} ${style.accepted}`}>
									{item.status}
								</p>

								<div className={style.details}>
									<h3 className={style.sectionTitle}>Customer Details</h3>
									<p className={style.info}>{item.name}</p>
									<p className={style.info}>{item.phone}</p>
									<p className={style.info}>{item.email}</p>
									<p className={style.info}>{item.service}</p>
									<p className={style.info}>{item.location}</p>
									<p className={style.info}>{item.message}</p>
								</div>

								<button
									className={style.updateButton}
									onClick={() => updateBookingStatus(item.order_number)}
								>
									Update to Work in Progress
								</button>

								<button
									className={style.updateButton}
									onClick={() => cancelBook(item.order_number)}
								>
									Cancel Booking
								</button>
							</div>
						))
					) : (
						<p className={style.noData}>No accepted bookings found.</p>
					)}
				</div>
			)}
			<BottomTab />
		</div>
	);
};

export default Accepted;
